// extracted by mini-css-extract-plugin
module.exports = {"recently-viewed-products":"style_recently-viewed-products__VNXkT","recently-viewed-products__list":"style_recently-viewed-products__list__03VoH"};